import { lowerCase, snakeCase } from 'lodash';
import { RESOURCE_TYPES } from '../../../constants';
import { BASE_PARAMS } from './constants';

export const createBigQueryEvent = (type, params) => ({
    collection = {},
    item = {},
    sourceInfo = {}
} = {}) => ({
    type,
    collection: {
        id: collection.id,
        name: collection.name,
        type: lowerCase(collection.ownerType),
        item: {
            id: item.id,
            type: lowerCase(item.resourceType)
        }
    },
    ...getItemResourceProps(item),
    event_source: snakeCase(sourceInfo.name),
    platform: sourceInfo.isTouch ? 'mobile_web' : 'web',
    user: {
        id: sourceInfo.userId
    },
    ...BASE_PARAMS,
    ...params
});

const getItemResourceProps = (item) => {
    const resourceProps = {
        id: item.resourceId
    };

    if (item.resourceType === RESOURCE_TYPES.GIG) {
        return { gig: resourceProps };
    }

    if (item.resourceType === RESOURCE_TYPES.SELLER) {
        return { seller: resourceProps };
    }

    return { inspireDelivery: resourceProps };
};
